"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = convertEvernoteToHTML;
exports.CONVERT_EVERNOTE_TO_HTML = void 0;

var _parseHTML = _interopRequireDefault(require("../utils/parseHTML"));

var _isValidPasteContent = _interopRequireDefault(require("../utils/isValidPasteContent"));

var CONVERT_EVERNOTE_TO_HTML = 'evernote';
exports.CONVERT_EVERNOTE_TO_HTML = CONVERT_EVERNOTE_TO_HTML;

function convertEvernoteToHTML(clipboardContent) {
  (0, _isValidPasteContent.default)(clipboardContent);
  return (0, _parseHTML.default)(clipboardContent.replace(/(\r\n|\n|\r)/, '')).outerHTML;
}